import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AngularFireAuth } from '@angular/fire/compat/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user: Observable<User>;
  errorMsg: string;

  constructor(private firebaseAuth: AngularFireAuth) {
    this.user = firebaseAuth.authState;
  }

  login(email: string, password: string) {
    this.firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        console.log('Successfully logged in to Firebase!');
        this.errorMsg = '';
      })
      .catch(err => {
        console.log('Couldnt log in to Firebase: ', err.message);
        this.errorMsg = 'Feil brukernavn eller passord.';
      });
  }

  logout() {
    this.firebaseAuth
      .signOut()
      .then(() => {
        console.log('Successfully logged out');
      });
  }
}

interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL: string;
  emailVerified: boolean;
}